import classNames from 'classnames';
import * as React from 'react';
import { compose, pure, withHandlers, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { FontIcon } from '../../FontIcon';
import { Popover } from '../../Popover';
import { Text } from '../../Text';
import styles from './DataTableSettingsPopoverStyles';
const DataTableSettingsPopover = (props) => {
    const { clickableComponent, children, classes, className } = props;
    return (React.createElement(Popover, { clickableComponent: clickableComponent, position: "bottomRight" },
        React.createElement("div", { className: classNames(classes.popoverContainer, className) }, children)));
};
export default compose(withState('open', 'setOpen', false), withStyles(styles), pure, withHandlers({
    clickableComponent: ({ classes, labelButton, iconSize, iconColor, icon = 'settings' }) => ({ setOpen, open }) => (React.createElement("div", { onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpen(!open);
        }, className: classes.buttonContainer },
        React.createElement(FontIcon, { iconName: icon, color: iconColor || 'currentColor', size: iconSize || 20, top: 3 }),
        labelButton && React.createElement(Text, null, labelButton))),
}))(DataTableSettingsPopover);
//# sourceMappingURL=DataTableSettingsPopover.js.map